import script from "./OkrFilterRelativeValues.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrFilterRelativeValues.vue?vue&type=script&setup=true&lang=js"

import "./OkrFilterRelativeValues.vue?vue&type=style&index=0&id=c5e8920e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5e8920e"]])

export default __exports__